import React from "react";
import { Outlet  } from "react-router-dom";
import { Shortcut, Navigation } from "../../navigation";
import EmbeddedHeader from './EmbeddedHeader';
import Header from "./Header";
import Footer from "./Footer";



class Layout extends React.Component {


    state = {
        embedded: false
    };

    componentDidMount() {
        var url_string = window.location.href;
        var url = new URL(url_string);
         
        var embedded = url.searchParams.get("embedded");   
        if (embedded !== null) {
            if (embedded.toUpperCase() === "TRUE") this.setState({ embedded: true });
        }
    }


    render() {
       
        var footer = <Footer />;
        var eheader = null; 

        if (this.state.embedded) {
           
            footer = null; 
            eheader = <EmbeddedHeader />;
        }
      
        return (
            <div>

                {this.state.embedded?  <></>:<Header onLoggedOut={this.props.onLoggedOut} /> }
                 
                <Navigation storex={this.props.storex}/>  
              

                <div id="main" role="main">

                    {eheader}
                        <Outlet /> 
                      
                 </div>

                {footer}
                <Shortcut />
            </div>
        );
    }
}


export default Layout;

